module.exports = __webpack_public_path__ + "img/save.45080466.svg";